module.exports = __webpack_public_path__ + "assets/img/28-m.3c4b521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/28-m.jpg
// module id = qHo6
// module chunks = 0